"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Step1 = void 0;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var ShoppingContextLoaded = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _checkoutMerchandising = require("@ori/checkout-merchandising");
var _checkoutUtils = require("@ori/checkout-utils");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
var _contexts = require("../contexts");
var _hooks = require("../hooks");
var _logger = require("../logger");
var _types = require("../types");
var _utils = require("../utils");
var _AddVoucher = require("./AddVoucher");
var _BannersSection = require("./BannerSection/BannersSection");
var _ClearBasket = require("./ClearBasket");
var _CombineSection = require("./CombineSection");
var _LoadingOverlay = require("./LoadingOverlay");
var _RecommendationsBar = require("./RecommendationsBar");
var _SectionAddedFree = require("./SectionAddedFree");
var _SectionAddedPaid = require("./SectionAddedPaid");
var _SectionConsumerOrders = require("./SectionConsumerOrders");
var _SectionMain = require("./SectionMain");
var _SectionShippingOffer = require("./SectionShippingOffer");
var _BasketStepSkeleton = require("./Skeletons/BasketStepSkeleton");
var _SubscriptionsSection = require("./SubscriptionsSection");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const Step1 = (param)=>{
    let { checkoutSummary: CheckoutSummary } = param;
    const { getTestId } = (0, _testidGenerator.default)();
    const { customerOrdersLink = '' } = (0, _contexts.useCheckoutBasket)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { isLoaded: isContextLoaded, isLoading } = (0, _shoppingContext.useShoppingContext)();
    // Used to force a re-fetch of the subscriptions data when subscribed item is removed from basket.
    const [shouldMutateCombineSection, setShouldMutateCombineSection] = (0, _react.useState)(false);
    const { feedbackNotificationSettings, handleClose, handleFeedbackOpen, isFeedbackOpen } = (0, _hooks.useFeedbackNotification)();
    const { icon: FeedbackNotificationIcon, messageKey } = feedbackNotificationSettings;
    const basketUpdatedHandler = (0, _react.useCallback)((event)=>{
        var _event_detail_lastAddedItem;
        if (typeof ((_event_detail_lastAddedItem = event.detail.lastAddedItem) === null || _event_detail_lastAddedItem === void 0 ? void 0 : _event_detail_lastAddedItem.frequency) !== 'undefined') {
            handleFeedbackOpen(_types.FeedbackNotificationType.Subscription);
        } else {
            (0, _utils.handleAutomaticSubscription)(event.detail.notifications, handleFeedbackOpen);
        }
    }, [
        handleFeedbackOpen
    ]);
    (0, _checkoutUtils.useWindowEvent)(BasketUpdated.Name, basketUpdatedHandler);
    (0, _checkoutUtils.useWindowEvent)(ShoppingContextLoaded.Name, basketUpdatedHandler);
    (0, _logger.logDebug)('Rendering Step1.tsx ...', {
        isContextLoaded,
        isLoading
    });
    if (!isContextLoaded) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BasketStepSkeleton.BasketStepSkeleton, {});
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.BasketContextProvider, {
        shouldMutateCombineSection: shouldMutateCombineSection,
        setShouldMutateCombineSection: setShouldMutateCombineSection,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styled.Step1Root, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_BannersSection.BannersSection, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styled.BasketCard, {
                    noPadding: true,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionMain.SectionMain, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionAddedFree.SectionAddedFree, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionAddedPaid.SectionAddedPaid, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionShippingOffer.SectionShippingOffer, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SectionConsumerOrders.SectionConsumerOrders, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_SubscriptionsSection.SubscriptionsSection, {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ClearBasket.ClearBasket, {})
                    ]
                }),
                isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LoadingOverlay.LoadingOverlay, {}) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CombineSection.CombineSection, {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_AddVoucher.AddVoucherFormWrapper, {}),
                !!CheckoutSummary && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styled.SummaryWrapper, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckoutSummary, {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutMerchandising.App, {
                    ordersPageLink: customerOrdersLink
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RecommendationsBar.RecommendationsBar, {}),
                (0, _tsUtils.isNonNullable)(messageKey) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FeedbackNotification, {
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeedbackNotificationIcon, {}),
                    open: isFeedbackOpen,
                    "aria-label": formatMessage(messageKey),
                    onClose: handleClose,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        "data-testid": getTestId('feedback-notification'),
                        children: formatMessage(messageKey)
                    })
                })
            ]
        })
    });
};
exports.Step1 = Step1;
